import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NavigationStart, Router, Event as RouterEvent, RouterOutlet, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TokenService } from './core/services/token.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { LanguageService } from './core/services/language.service';
import { ScrollToTopComponent } from './shared/components/scroll-to-top/scroll-to-top.component';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { IdleTimeoutDialogComponent } from './shared/components/idle-timeout-dialog/idle-timeout-dialog.component';
import { DataService } from './core/services/data.service';

@Component({
  selector: 'app-root',
  standalone:true,
  imports: [RouterOutlet, CommonModule, SpinnerComponent, ScrollToTopComponent, IdleTimeoutDialogComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = '';
  public base = '';
  public page = '';
  showIdleDialog = false;

  constructor(
    private router: Router,
    private titleService: Title,
    private tokenService: TokenService,
    private languageService: LanguageService,
    private idleTimeoutService: IdleTimeoutService,
    private dataService: DataService
  ) {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        const URL = event.url.split('/');
        this.base =URL[1] ? URL[1].replace('-',' '): '';
        this.page = URL[2] ? URL[2].replace('-',' '): '';
      }
      if(this.base === 'home'){
        this.page = 'Deals Dashboard'
      }
      if(this.base === 'lead dashboard' || this.base === 'project dashboard'
        ||this.base ==='pipeline' || this.base === 'payments' ||this.base === 'analytics' ||this.base === 'sources'
        ||this.base ==='lost reason' || this.base === 'contact stage' ||this.base === 'industry' ||this.base === 'calls'
        ||this.base ==='manage users' || this.base === 'roles permissions' ||this.base === 'permission' ||this.base === 'delete request'
        ||this.base ==='pages' || this.base === 'roles permissions' ||this.base === 'testimonials' ||this.base === 'faq'
        ||this.base ==='contact messages' || this.base === 'tickets' ||this.base === 'testimonials' ||this.base === 'faq'
        ||this.base ==='login' || this.base === 'forgot password' ||this.base === 'email verification' ||this.base === 'two step verification'
        ||this.base ==='reset password' || this.base === 'coming soon' ||this.base === 'under maintenance' 
        ||this.base ==='layout fullwidth' || this.base === 'layout hoverview' ||this.base === 'layout rtl' 
        ||this.base ==='layout mini' || this.base === 'layout hidden' ||this.base === 'layout dark' 
        ||this.base ==='notifications' 
      ){
        this.page = this.base
      }
      
      // Update page title on navigation end
      if (event instanceof NavigationEnd) {
        // Check if page looks like a GUID or ID parameter (contains mostly hex chars and spaces from replaced dashes)
        const isGuidOrId = /^[0-9a-f\s-]{20,}$/i.test(this.page) || /^[0-9]+$/.test(this.page) || this.page === '';
        const pageName = isGuidOrId ? this.base : (this.page || this.base || 'Home');
        const formattedName = pageName.charAt(0).toUpperCase() + pageName.slice(1);
        this.titleService.setTitle(`Business - ${formattedName}`);
      }
    });
  }

  ngOnInit() {
    this.manageTabs();
    this.startIdleWatch();
    this.listenForCrossTabLogin();
  }

  ngOnDestroy() {
    this.idleTimeoutService.stop();
  }

  private startIdleWatch(): void {
    if (this.tokenService.isAuthenticated()) {
      this.idleTimeoutService.start(
        () => this.showIdleDialog = true,
        () => this.showIdleDialog = false
      );
    }

    this.tokenService.token$.subscribe(isAuth => {
      if (isAuth) {
        this.idleTimeoutService.start(
          () => this.showIdleDialog = true,
          () => this.showIdleDialog = false
        );
      } else {
        this.idleTimeoutService.stop();
        this.showIdleDialog = false;
      }
    });
  }

  onIdleContinue(): void {
    this.showIdleDialog = false;
    this.idleTimeoutService.continueSession();
  }

  onIdleLogout(): void {
    this.showIdleDialog = false;
    this.idleTimeoutService.logout();
  }

  private listenForCrossTabLogin(): void {
    window.addEventListener('storage', (event) => {
      if (event.key === 'login_broadcast' && this.tokenService.isAuthenticated()) {
        this.dataService.initializeSession();
        const selectedSection = this.dataService.getSelectedSection();
        const sectionRoutes: { [key: string]: string } = {
          BtakkaInterface: 'home',
          BtakkaErp: 'Account',
          BtakkaOperation: 'operation',
        };
        const targetRoute = sectionRoutes[selectedSection] || 'home';
        this.router.navigate([targetRoute]);
      }
    });
  }

  private manageTabs() {
    const isRefresh = !!sessionStorage.getItem('tab_id');
    const tabId = sessionStorage.getItem('tab_id') || Math.random().toString(36).substring(2);
    sessionStorage.setItem('tab_id', tabId);

    const getActiveTabsCount = () => {
      const tabs = JSON.parse(localStorage.getItem('active_tabs_map') || '{}');
      const now = Date.now();
      let count = 0;
      
      for (const id in tabs) {
        if (now - tabs[id] < 5000) {
          count++;
        } else {
          delete tabs[id]; 
        }
      }
      localStorage.setItem('active_tabs_map', JSON.stringify(tabs));
      return count;
    };

    if (!isRefresh && getActiveTabsCount() === 0) {
      this.tokenService.fullCleanup();
    }

    const updatePulse = () => {
      const tabs = JSON.parse(localStorage.getItem('active_tabs_map') || '{}');
      tabs[tabId] = Date.now();
      localStorage.setItem('active_tabs_map', JSON.stringify(tabs));
    };

    updatePulse();
    setInterval(updatePulse, 2000);

    window.addEventListener('beforeunload', () => {
      const tabs = JSON.parse(localStorage.getItem('active_tabs_map') || '{}');
      delete tabs[tabId];
      localStorage.setItem('active_tabs_map', JSON.stringify(tabs));
    });
  }
}
